'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' });

var CropSquare = function CropSquare(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

CropSquare = (0, _pure2.default)(CropSquare);
CropSquare.muiName = 'SvgIcon';

exports.default = CropSquare;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/CropSquare.js
// module id = 2297
// module chunks = 0